const RemoveActionType = Object.freeze({
  Delete: 1,
  UnSubscribe: 2,
});
export default RemoveActionType;
